// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.split-table-container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.single-table-container {
  display: block;
}

.table-section {
  flex: 1;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNwbGl0LXRhYmxlLmNvbXBvbmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDTTtFQUNFLGFBQUE7RUFDQSxtQkFBQTtFQUNBLFNBQUE7QUFBUjs7QUFHTTtFQUNFLGNBQUE7QUFBUjs7QUFHTTtFQUNFLE9BQUE7QUFBUiIsImZpbGUiOiJzcGxpdC10YWJsZS5jb21wb25lbnQudHMiLCJzb3VyY2VzQ29udGVudCI6WyJcbiAgICAgIC5zcGxpdC10YWJsZS1jb250YWluZXIge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICAgICAgICBnYXA6IDFyZW07XG4gICAgICB9XG5cbiAgICAgIC5zaW5nbGUtdGFibGUtY29udGFpbmVyIHtcbiAgICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICB9XG5cbiAgICAgIC50YWJsZS1zZWN0aW9uIHtcbiAgICAgICAgZmxleDogMTtcbiAgICAgIH1cbiAgICAiXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/split-table/split-table.component.ts"],"names":[],"mappings":"AACM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAAR;;AAGM;EACE,cAAA;AAAR;;AAGM;EACE,OAAA;AAAR;AACA,wpBAAwpB","sourcesContent":["\n      .split-table-container {\n        display: flex;\n        flex-direction: row;\n        gap: 1rem;\n      }\n\n      .single-table-container {\n        display: block;\n      }\n\n      .table-section {\n        flex: 1;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
